<template>
    <Head title="Users"/>
    <list-page-template
        name="Users"
        route="users.index"
        :filters="filters" v-model:sort="currentSort" :sort-options="sortOptions" v-model:active-filters="activeFilters"
        description="Manage active and inactive users of the system">
        <h2 id="products-heading" class="sr-only">Users</h2>
        <div class="flex flex-col">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                            <tr>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Phone Number</th>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Roles</th>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Active</th>
                            </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="user in pagination.data" class="cursor-pointer" :key="user.id">
                                <td class="px-6 py-4 whitespace-nowrap ">
                                    <div class="flex items-center">
                                        <div class="flex-shrink-0 h-10 w-10">
                                            <div v-if="!user.image_url" class="h-10 w-10 rounded-full overflow-hidden">
                                                <svg class="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                                                </svg>
                                            </div>
                                            <img v-if="user.image_url" class="h-10 w-10 rounded-full object-cover" :src="user.image_url" alt="" />
                                        </div>
                                        <div class="ml-4 flex flex-col">
                                            {{ user.name }}
                                            <span class="text-sm text-gray-500">{{ user.email }}</span>
                                        </div>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm text-gray-500">{{ user.phone_number ?? "-" }}</div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    {{ getRoleList(user.roles) }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <span
                                        :class="true ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
                                        class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"> {{ true ? "Yes" : "No" }} </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <pagination :pagination="this.pagination" />
    </list-page-template>
</template>

<script>
import Layout from '@/Shared/Layout'
import { isProxy, toRaw } from "vue"
import Pagination from '@/Shared/Pagination'
import { Head } from "@inertiajs/inertia-vue3";
import ListPageTemplate from "@/Shared/PageSegments/ListPageTemplate";

export default {
    layout: Layout,
    props: {
        auth: Object,
        sort: String,
        filters: Object,
        pagination: Object,
        sortOptions: Object,
        filterOptions: Object,
    },
    components: {
        Head,
        Pagination,
        ListPageTemplate,
    },
    data() {
        return {
            currentSort: this.sort ?? '',
            activeFilters: []
        }
    },
    setup(props) {
        return {
            sortOptions: isProxy(props.sortOptions) ? toRaw(props.sortOptions) : props.sortOptions,
            filters: isProxy(props.filterOptions) ? toRaw(props.filterOptions) : props.filterOptions,
        }
    },
    methods: {
        getRoleList(roles) {
            return roles.map(r => r.name).join(", ")
        }
    }
}
</script>
